import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const CopyLinkMenuItem = ({ onClick }: { onClick: () => void }) => {
  return (
    <DropdownMenuItem
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
    >
      <FontAwesomeIcon icon={faCopy} size="lg" />
      <MenuItemLabel>Copy link</MenuItemLabel>
    </DropdownMenuItem>
  );
};
